import { render } from "./GlobalSearch.vue?vue&type=template&id=9cd1ce3c"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"GlobalSearch.vue"]])

export default __exports__